import { Mandate } from "@/api/openapi";
import { faCircle } from "@fortawesome/pro-light-svg-icons";
import { faCircleCheck as faCircleCheckFilled } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";

type MandatePopupElementProps = {
  onSelectMandate: (mandate: Mandate) => void;
  mandate: Mandate;
  selectedMandateId?: string;
};

export default function MandatePopupElement({
  onSelectMandate,
  mandate,
  selectedMandateId,
}: MandatePopupElementProps) {
  return (
    <div
      onClick={() => onSelectMandate(mandate)}
      className={clsx(
        "flex",
        "flex-row",
        "justify-between",
        "items-center",
        "cursor-pointer",
        "-mx-3",
        "px-3",
        "py-2",
        mandate.id === selectedMandateId && "bg-primary-50",
      )}
      key={`switch-mandate-option-${mandate.id}`}
    >
      <div className="flex flex-col items-start">
        <div className="font-medium text-base">{mandate.name}</div>
        <div className="text-font-secondary text-base">
          {mandate.taxNumber.toUpperCase()}
        </div>
      </div>
      <FontAwesomeIcon
        icon={mandate.id === selectedMandateId ? faCircleCheckFilled : faCircle}
        className={clsx(
          "text-xl",
          mandate.id === selectedMandateId
            ? "text-primary"
            : "text-font-secondary",
        )}
      />
    </div>
  );
}
